import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b64c144"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "nge-cfm-title" }
const _hoisted_3 = { class: "nge-cfm-text" }
const _hoisted_4 = { class: "nge-cfm-btns" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "nge-cfm-backdrop",
      onClick: _cache[2] || (_cache[2] = _withModifiers($event => ($setup.emit('no')), ["self"]))
    }, [
      _createElementVNode("div", {
        class: "nge-cfm",
        role: "alertdialog",
        "aria-modal": "true",
        "aria-label": $props.title
      }, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString($props.title), 1 /* TEXT */),
        _createElementVNode("p", _hoisted_3, _toDisplayString($props.text), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            ref: "cancelEl",
            class: "nge-cfm-no",
            onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('no')))
          }, "Cancel", 512 /* NEED_PATCH */),
          _createElementVNode("button", {
            class: "nge-cfm-yes",
            onClick: _cache[1] || (_cache[1] = $event => ($setup.emit('yes')))
          }, _toDisplayString($props.yes), 1 /* TEXT */)
        ])
      ], 8 /* PROPS */, _hoisted_1)
    ])
  ]))
}